import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_PsychiatricEM = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_PsychiatricEM' className='file-pdf-document'>
            <div className='file-template'>
                <h3>General Information</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Chief Compliant/Reason for Visit:</span>
                    <span className='small'> (Include medication changes from last appointment and current efficacy) </span>
                    <textarea id="txtChiefCompliant" name="txtChiefCompliant" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Interval History :</span>
                    <span className='small'>(location, severity, quality, timing, modifying factors, and associated signs/symptoms)</span>
                    <textarea id="txtIntervalHistory" name="txtIntervalHistory" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Review of Systems:</span>
                    <textarea id="txtReviewSystems" name="txtReviewSystems" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments/Psychotherapy Note:</span>
                    <textarea id="txtAdditionalComments" name="txtAdditionalComments" className="add-only"></textarea>
                </p>


                <h3>Constitutional Examination</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Vital Signs: </span>
                    <input type="checkbox" id='cbVitalSigns_1' name="cbVitalSigns_1" className='add-only' value="VitalSigns_1" /> Not taken due to telehealth session &nbsp; &nbsp;
                    <input type="checkbox" id='cbVitalSigns_2' name="cbVitalSigns_2" className='add-only' value="VitalSigns_2" /> See nursing assessment
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>BP:</span>
                            <input type='text' id="txtBP" name="txtBP" className='add-only' />
                        </td>
                        <td className='w-250'><span className='eleHeader'>Pulse:</span>
                            <input type='text' id="txtPulse" name="txtPulse" className='add-only' />
                        </td>
                        <td className='w-250'><span className='eleHeader'>Respiration:</span>
                            <input type='text' id="txtRespiration" name="txtRespiration" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Temp:</span>
                            <input type='text' id="txtTemp" name="txtTemp" className='add-only' />
                        </td>
                        <td className='w-250'><span className='eleHeader'>Height:</span>
                            <input type='text' id="txtHeight" name="txtHeight" className='add-only' />
                        </td>
                        <td className='w-250'><span className='eleHeader'>Weight:</span>
                            <input type='text' id="txtWeight" name="txtWeight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>BMI:</span>
                            <input type='text' id="txtBMI" name="txtBMI" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Constitutional:</span>
                    <textarea id="txtConstitutional" name="txtConstitutional" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Appetite:</span>
                            <input type="text" id="txtAppetite" name="txtAppetite" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>SI:</span>
                            <input type="radio" id="rbSI_Denied" name="rb_SI" className='add-only' value="0" /> Denied  &nbsp;
                            <input type="radio" id="rbSI_yes" name="rb_SI" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Sleep:</span>
                            <input type="text" id="txtSleep" name="txtSleep" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>HI:</span>
                            <input type="radio" id="rbHI_Denied" name="rb_HI" className='add-only' value="0" /> Denied  &nbsp;
                            <input type="radio" id="rbHI_yes" name="rb_HI" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Energy:</span>
                            <input type="text" id="txtEnergy" name="txtEnergy" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>A/V Hallucinations:</span>
                            <input type="radio" id="rbHallucinations_Denied" name="rb_Hallucinations" className='add-only' value="0" /> Denied  &nbsp;
                            <input type="radio" id="rbHallucinations_yes" name="rb_Hallucinations" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Able to contract for safety?</span>
                            <input type="radio" id="rbAblecontractsafety_Yes" name="rbAblecontractsafety" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbAblecontractsafety_No" name="rbAblecontractsafety" className='add-only' value="0" /> No

                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aggression:</span>
                            <input type="radio" id="rbAggression_Denied" name="rb_Aggression" className='add-only' value="0" /> Denied  &nbsp;
                            <input type="radio" id="rbAggression_yes" name="rb_Aggression" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments</span>
                    <span className="small block">(describe any responses not WNL from above):</span>
                    <textarea id="txtCommentsdescriberesponses" name="txtCommentsdescriberesponses" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abnormal Involuntary Movement Scale </span>
                    <span className="small block">(AIMS)</span>
                    <input type="radio" id="rbAbnormalInvoluntaryMovement_1" name="rbAbnormalInvoluntaryMovement" className='add-only' value="Not applicable" /> Not applicable  &nbsp;&nbsp;
                    <input type="radio" id="rbAbnormalInvoluntaryMovement_2" name="rbAbnormalInvoluntaryMovement" className='add-only' value="Negative" /> Negative    &nbsp;&nbsp;
                    <input type="radio" id="rbAbnormalInvoluntaryMovement_3" name="rbAbnormalInvoluntaryMovement" className='add-only' value="Positive" /> Positive
                </p>
                <p className='w-750'>
                    <textarea id="txtAbnormalInvoluntaryMovement_3" name="txtAbnormalInvoluntaryMovement_3" className="add-only"></textarea>
                </p>

                
                <h3>
                    Abnormal Involuntary Movement Scale (AIMS)
                </h3>
                <h4>
                    (Required ONLYfor clients on anti-psychotic medications)
                </h4>
                <p className='w-750'>
                    <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='NotApplicable' />  Not applicable
                </p>
                <p className='w-750'>
                    <strong>Movement Ratings:</strong> Rate highest severity observed. Rate movements that occur upon activation one less than those observed spontaneously. Select movement as well as code number that applies.
                </p>
                <p className='w-750'>
                    Rater:<input type="text" id="txtRater" name="txtRater" className='add-only' />
                </p>
                <h4>
                    Facial and Oral Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. Muscles of Facial Expression </span><span className='small'>(i.e., movements of forehead, eyebrows, periorbital area, cheeks, including frowning, blinking, smiling, grimacing) </span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Yes' name='rbMuscles' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Ys' name='rbMuscles' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_No' name='rbMuscles' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Ye' name='rbMuscles' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Yi' name='rbMuscles' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. Lips and Perioral Area </span><span className='small'>(i.e., puckering, pouting, smacking)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Yes' name='rbLips' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Ys' name='rbLips' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_No' name='rbLips' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Ye' name='rbLips' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Yi' name='rbLips' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. Jaw</span><span className='small'> (i.e., biting, clenching, chewing, mouth opening, lateral movement)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Yes' name='rbJaw' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Ys' name='rbJaw' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_No' name='rbJaw' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Ye' name='rbJaw' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Yi' name='rbJaw' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. Tongue </span><span className='small'> (i.e., Rate only increases in movement both in and out of mouth. NOT inability or sustain movement.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Yes' name='rbTongue' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Ys' name='rbTongue' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_No' name='rbTongue' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Ye' name='rbTongue' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Yi' name='rbTongue' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Extremity Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>5. Upper (arms, wrists, hands, fingers) Include chroreic movements (i.e., rapid, objectively purposeless, irregular, spontaneous) athetoid movements. DO NOT INCLUDE TREMOR.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Yes' name='rbUpper' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Ys' name='rbUpper' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_No' name='rbUpper' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Ye' name='rbUpper' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Yi' name='rbUpper' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>6. Lower (legs, knees, ankles, toes) i.e., lateral knee movement, foot tapping, heel dropping, foot squirming, inversion and eversion of foot.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Yes' name='rbLower' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Ys' name='rbLower' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_No' name='rbLower' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Ye' name='rbLower' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Yi' name='rbLower' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Trunk Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>7. Neck, shoulders, hips </span><span className='small'>(i.e., rocking, twisting, squirming, pelvic gyrations)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Yes' name='rbNeck' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Ys' name='rbNeck' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_No' name='rbNeck' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Ye' name='rbNeck' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Yi' name='rbNeck' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Global Judgments
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. Severity of abnormal movements overall</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Yes' name='rbSeverity' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Ys' name='rbSeverity' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_No' name='rbSeverity' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Ye' name='rbSeverity' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Yi' name='rbSeverity' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>9. Incapacitation due to abnormal movements</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Yes' name='rbIncapacitation' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Ys' name='rbIncapacitation' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_No' name='rbIncapacitation' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Ye' name='rbIncapacitation' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Yi' name='rbIncapacitation' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>10. Individual's awareness of abnormal movements. Rate only individual's report.
                            No awareness = 0 Aware, no distress = 1 Aware, mild distress = 2 Aware, moderate distress = 3 Aware, severe distress = 4 </span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Yes' name='rbAwareness' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Ys' name='rbAwareness' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_No' name='rbAwareness' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Ye' name='rbAwareness' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Yi' name='rbAwareness' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Dental Status
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>11. Current problems with teeth and/or dentures</span>
                    <input type='radio' id='rbDentures_Yes' name='rbDentures' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbDentures_No' name='rbDentures' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>12. Are dentures usually worn?</span>
                    <input type='radio' id='rbWorn_Yes' name='rbWorn' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbWorn_No' name='rbWorn' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>13. Edentia?</span>
                    <input type='radio' id='rbEdentia_Yes' name='rbEdentia' className='add-only' value='0' /> &nbsp; No&nbsp;
                    <input type='radio' id='rbEdentia_No' name='rbEdentia' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>14. Do movements disappear in sleep?</span>
                    <input type='radio' id='rbMovements_Yes' name='rbMovements' className='add-only' value='0' /> &nbsp; No&nbsp;
                    <input type='radio' id='rbMovements_No' name='rbMovements' className='add-only' value='1' /> &nbsp;  Yes
                </p>




                <h3><center> History</center></h3>

                <p className='w-750'>
                    <span className='eleHeader'>Past Psychiatric History:</span>
                    <input type="radio" id="rbPastPsychiatricHistory_Denied" name="rb_PastPsychiatricHistory" className='add-only' value="0" /> Denied  &nbsp;
                    <input type="radio" id="rbPastPsychiatricHistory_yes" name="rb_PastPsychiatricHistory" className='add-only' value="1" /> Yes (describe below):
                    <textarea id="txtPastPsychiatricHistory" name="txtPastPsychiatricHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Social History:</span>
                    <input type="checkbox" id="cbSocialHistory_Denied" name="cbSocialHistory_Denied" className='add-only' value="Denied" />Denied
                    <textarea id="txtSocialHistory" name="txtSocialHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical History:</span>
                    <input type="checkbox" id="cbMedicalHistory_Denied" name="cbMedicalHistory_Denied" className='add-only' value="Denied" />Denied
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <input type="radio" id="rbAllergies_Denied" name="rb_Allergies" className='add-only' value="0" /> Denied/None Known &nbsp;
                    <input type="radio" id="rbAllergies_yes" name="rb_Allergies" className='add-only' value="1" /> Yes (describe):&nbsp;
                    <textarea id="txtAllergies" name="txtAllergies" className="add-only"></textarea>
                </p>

                <h3>Mental Status Exam</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Well groomed' /> Well groomed </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Casual' /> Casual </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Disheveled' /> Disheveled </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='Unkempt' /> Unkempt</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_5' name='cbAppearance_5' className='add-only' value='Bizarre' /> Bizarre </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_6' name='cbAppearance_6' className='add-only' value='Inappropriate' /> Inappropriate </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_7' name='cbAppearance_7' className='add-only' value='Malodorous' /> Malodorous </td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_8' name='cbAppearance_8' className='add-only' value='Physical Impairment' /> Physical Impairment</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Build</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBuild_1' name='cbBuild_1' className='add-only' value='Average Build' /> Average Build </td>
                        <td className='w-187'><input type='checkbox' id='cbBuild_2' name='cbBuild_2' className='add-only' value='Thin' /> Thin </td>
                        <td className='w-187'><input type='checkbox' id='cbBuild_3' name='cbBuild_3' className='add-only' value='Overweight' /> Overweight </td>
                        <td className='w-187'><input type='checkbox' id='cbBuild_4' name='cbBuild_4' className='add-only' value='Obese' /> Obese</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBuild_5' name='cbBuild_5' className='add-only' value='Average height ' /> Average height  </td>
                        <td className='w-187'><input type='checkbox' id='cbBuild_6' name='cbBuild_6' className='add-only' value='Tall ' /> Tall  </td>
                        <td className='w-187'><input type='checkbox' id='cbBuild_7' name='cbBuild_7' className='add-only' value='Short ' /> Short  </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Demeanor</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_1' name='cbDemeanor_1' className='add-only' value='Cooperative' /> Cooperative </td>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_2' name='cbDemeanor_2' className='add-only' value='Hostile' /> Hostile </td>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_3' name='cbDemeanor_3' className='add-only' value='Guarded' /> Guarded </td>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_4' name='txtDemeanor_4' className='add-only' value='Withdrawn' /> Withdrawn</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_5' name='cbDemeanor_5' className='add-only' value='Preoccupied ' /> Preoccupied </td>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_6' name='cbDemeanor_6' className='add-only' value='Demanding' /> Demanding  </td>
                        <td className='w-187'><input type='checkbox' id='cbDemeanor_7' name='cbDemeanor_7' className='add-only' value='Seductive' /> Seductive  </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Normal' /> Normal  </td>
                        <td className='w-187'><input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Labile' /> Labile  </td>
                        <td className='w-187'><input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Flat' /> Flat   </td>
                        <td className='w-187'><input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Worrisome' />  Worrisome </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Sad' />Sad  </td>
                        <td className='w-187'><input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Apathetic' /> Apathetic   </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Depressed' /> Depressed </td>
                        <td className='w-187'><input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Anxious' /> Anxious </td>
                        <td className='w-187'><input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Euphoric' /> Euphoric</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Irritable' /> Irritable </td>
                        <td className='w-187'><input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Dysphoric' /> Dysphoric </td>
                        <td className='w-187'><input type='checkbox' id='cbMood_7' name='cbMood_7' className='add-only' value='Angry' /> Angry </td>
                        <td className='w-187'><input type='checkbox' id='cbMood_8' name='cbMood_8' className='add-only' value='Euthymic ' />Euthymic </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_1' name='cbBehavior_1' className='add-only' value='Appropriate' /> Appropriate  </td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_2' name='cbBehavior_2' className='add-only' value='Hyperactive' /> Hyperactive  </td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_3' name='cbBehavior_3' className='add-only' value='Hypoactive' /> Hypoactive   </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_4' name='cbBehavior_4' className='add-only' value='Restless' />  Restless </td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_5' name='cbBehavior_5' className='add-only' value='Relaxed' />Relaxed  </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbBehavior_6' name='cbBehavior_6' className='add-only' value='Other' /> Other
                            <input type='text' id="txtBehavior_6" name="txtBehavior_6" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEyeContact_1' name='cbEyeContact_1' className='add-only' value='Average' /> Average  </td>
                        <td className='w-187'><input type='checkbox' id='cbEyeContact_2' name='cbEyeContact_2' className='add-only' value='Decreased' /> Decreased  </td>
                        <td className='w-187'><input type='checkbox' id='cbEyeContact_3' name='cbEyeContact_3' className='add-only' value='Increased' /> Increased   </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Clear' /> Clear</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Slurred' /> Slurred </td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Rapid' /> Rapid </td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Slow' /> Slow</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Pressured' /> Pressured </td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Soft' /> Soft </td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Loud' /> Loud </td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Monotone' />Monotone </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Process</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_1' name='cbThoughtProcess_1' className='add-only' value='Logical' /> Logical</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_2' name='cbThoughtProcess_2' className='add-only' value='Coherent' /> Coherent </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_3' name='cbThoughtProcess_3' className='add-only' value='Tight' /> Tight </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_4' name='cbThoughtProcess_4' className='add-only' value='Linear' /> Linear</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_5' name='cbThoughtProcess_5' className='add-only' value='Disorganized' /> Disorganized </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_6' name='cbThoughtProcess_6' className='add-only' value='Flight of Ideas' /> Flight of Ideas </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_7' name='cbThoughtProcess_7' className='add-only' value='Loose Associations' /> Loose Associations </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtProcess_8' name='cbThoughtProcess_8' className='add-only' value='Word Salad' />Word Salad </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Content</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_1' name='cbThoughtContent_1' className='add-only' value='Within Normal Limits' /> Within Normal Limits</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_2' name='cbThoughtContent_2' className='add-only' value='Hallucinations' /> Hallucinations </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_3' name='cbThoughtContent_3' className='add-only' value='Delusions' /> Delusions  </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_4' name='cbThoughtContent_4' className='add-only' value='Persecution Ideas' /> Persecution Ideas</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_5' name='cbThoughtContent_5' className='add-only' value='Suicidal Ideation' /> Suicidal Ideation </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_6' name='cbThoughtContent_6' className='add-only' value='Homicidal Ideation' /> Homicidal Ideation </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_7' name='cbThoughtContent_7' className='add-only' value='Derealization' /> Derealization  </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_8' name='cbThoughtContent_8' className='add-only' value='Depersonalization' />Depersonalization </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_9' name='cbThoughtContent_9' className='add-only' value='Ideas of Reference' /> Ideas of Reference </td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_10' name='cbThoughtContent_10' className='add-only' value='Preoccupations' /> Preoccupations</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_11' name='cbThoughtContent_11' className='add-only' value='Strange Experiences' />Strange Experiences</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtContent_12' name='cbThoughtContent_12' className='add-only' value='Obsessions' />Obsessions</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInsight_1' name='cbInsight_1' className='add-only' value=' Age Appropriate' />Age Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_2' name='cbInsight_2' className='add-only' value='Limited' />Limited</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_3' name='cbInsight_3' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_4' name='cbInsight_4' className='add-only' value='Unclear' /> Unclear</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Judgment</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_1' name='cbJudgment_1' className='add-only' value=' Age Appropriate' />Age Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_2' name='cbJudgment_2' className='add-only' value='Limited' />Limited</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_3' name='cbJudgment_3' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_4' name='cbJudgment_4' className='add-only' value='Unclear' /> Unclear</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Memory</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMemory_1' name='cbMemory_1' className='add-only' value='Intact' />Intact</td>
                        <td className='w-187'><input type='checkbox' id='cbMemory_2' name='cbMemory_2' className='add-only' value='Recent Intact' />Recent Intact</td>
                        <td className='w-187'><input type='checkbox' id='cbMemory_3' name='cbMemory_3' className='add-only' value='Remote intact' />Remote intact</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Orientation</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Person' />Person</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Place' />Place</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Time' />Time</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Situation' />Situation </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Motivation</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMotivation_1' name='cbMotivation_1' className='add-only' value='Good' />Good </td>
                        <td className='w-187'><input type='checkbox' id='cbMotivation_2' name='cbMotivation_2' className='add-only' value='Fair' />Fair </td>
                        <td className='w-187'><input type='checkbox' id='cbMotivation_3' name='cbMotivation_3' className='add-only' value='Poor' />Poor </td>
                        <td className='w-187'><input type='checkbox' id='cbMotivation_4' name='cbMotivation_4' className='add-only' value='Unclear' />Unclear</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments regarding any items of concerns above outside of normal limits:</span>
                    <textarea id="txtCommentsRegardingItems" name="txtCommentsRegardingItems" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Diagnoses</span>
                    <span className="small block">(Add or remove rows as needed)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'><input type="text" id="txtDiagnoses_1" name="txtDiagnoses_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'><input type="text" id="txtDiagnoses_2" name="txtDiagnoses_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'><input type="text" id="txtDiagnoses_3" name="txtDiagnoses_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>4.</td>
                        <td className='w-730'><input type="text" id="txtDiagnoses_4" name="txtDiagnoses_4" className='add-only' /></td>
                    </tr>
                </table>
                <h3>Recommendations/Plan</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Service Recommendations:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_1' name='cbServiceRecommendations_1' className='add-only' value='ServiceRecommendations_1' />(C&A CORE) Individual/family therapy services 1-4 x monthly, CSI 2-8 x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_2' name='cbServiceRecommendations_2' className='add-only' value='ServiceRecommendations_2' /> (C&A IFI) IFI services 3-8 x weekly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_3' name='cbServiceRecommendations_3' className='add-only' value='ServiceRecommendations_3' />(Adult CORE) Individual/family therapy services 1-4 x monthly, PSR-I 2-8 x monthly, case management 2-8x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_4' name='cbServiceRecommendations_4' className='add-only' value='ServiceRecommendations_4' />Other:
                            <input type="text" id="txtServiceRecommendations_4" name="txtServiceRecommendations_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Labs Requested Today?: </span>
                    <input type="radio" id="rbLabsRequested_No" name="rbLabsRequested" className='add-only' value="0" /> No &nbsp;
                    <input type="radio" id="rbLabsRequested_yes" name="rbLabsRequested" className='add-only' value="1" /> Yes:   &nbsp;
                    <textarea id="txtLabsRequested" name="txtLabsRequested" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMedications_1' name='cbMedications_1' className='add-only' value='Medications_1' />No medications prescribed at this time.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMedications_2' name='cbMedications_2' className='add-only' value='Medications_2' />Continue meds aspreviously prescribed &nbsp;&nbsp;
                    <textarea id="txtMedications_2" name="txtMedications_2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMedications_3' name='cbMedications_3' className='add-only' value='Medications_3' /> New medications prescribed (including increases/decreases in dosages)&nbsp;&nbsp;
                    <textarea id="txtMedications_3" name="txtMedications_3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMedications_4' name='cbMedications_4' className='add-only' value='Medications_4' /> Medications discontinued &nbsp;&nbsp;
                    <textarea id="txtMedications_4" name="txtMedications_4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Education of Side Effects:</span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbEducationSideEffects' name='cbEducationSideEffects' className='add-only' value='None' />None &nbsp;&nbsp;
                    <textarea id="txtEducationSideEffects" name="txtEducationSideEffects" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Follow up:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFollowUp_1' name='cbFollowUp_1' className='add-only' value='4-8 weeks' />4-8 weeks</td>
                        <td className='w-187'><input type='checkbox' id='cbFollowUp_2' name='cbFollowUp_2' className='add-only' value=' 8-12 weeks' /> 8-12 weeks</td>
                        <td className='w-187'><input type='checkbox' id='cbFollowUp_3' name='cbFollowUp_3' className='add-only' value='Annually/as needed' />Annually/as needed</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbFollowUp_4' name='cbFollowUp_4' className='add-only' value='Other:' />Other:
                            <input type="text" id="txtFollowUp_4" name="txtFollowUp_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                {/* <table>
                    <tr>
                        <td className='w-750 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-750 ">Physician Signature/Credentials:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450 signature'  >&nbsp;
                        </td>
                        <td className='w-300 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-450 ">Physician Name/Credentials (Print):
                        </td>
                        <td className="small w-300">Date:
                        </td>
                    </tr>
                </table> */}

            </div>
        </form>

    )
}  